import React from 'react'
import SentimentVeryDissatisfiedRoundedIcon from '@mui/icons-material/SentimentVeryDissatisfiedRounded'
import SentimentDissatisfiedRoundedIcon from '@mui/icons-material/SentimentDissatisfiedRounded'
import SentimentNeutralRoundedIcon from '@mui/icons-material/SentimentNeutralRounded'
import SentimentSatisfiedRoundedIcon from '@mui/icons-material/SentimentSatisfiedRounded'
import SentimentVerySatisfiedRoundedIcon from '@mui/icons-material/SentimentVerySatisfiedRounded'
import { Mood } from 'src/feed/ResponseItem/SectionEntry/EntryValues/MoodValue'
import { advancedColors } from '../../../theme'

// Standard's moods, drawn with MUI's sentiment icons rather than its SVG set.
const MOOD_ICONS: Record<Mood, typeof SentimentNeutralRoundedIcon> = {
  [Mood.Angry]: SentimentVeryDissatisfiedRoundedIcon,
  [Mood.Unhappy]: SentimentDissatisfiedRoundedIcon,
  [Mood.Indifferent]: SentimentNeutralRoundedIcon,
  [Mood.Happy]: SentimentSatisfiedRoundedIcon,
  [Mood.Laughing]: SentimentVerySatisfiedRoundedIcon,
}

const MoodValue = ({ value }: { value: Mood }) => {
  const Icon = MOOD_ICONS[value]

  return <Icon fontSize="small" sx={{ color: advancedColors.green }} titleAccess={value} />
}

export default MoodValue
